export default {
	default: 5 * 1000,
	basket: 5 * 60 * 1000,
	translations: 15 * 60 * 1000,
	layout: 15 * 60 * 1000,
	account: 15 * 60 * 1000,
	order: 5 * 60 * 1000,
	product: 5 * 60 * 1000,
	productCategory: 15 * 60 * 1000,
	settings: 15 * 60 * 1000,
	cms: 30 * 1000,
	image: 60 * 60 * 1000,
	routing: 60 * 60 * 1000,
	customerList: 15 * 60 * 1000,
	customers: 15 * 60 * 1000,
	customer: 15 * 60 * 1000,
	appSolutionBuilder: 15 * 60 * 1000,
	registrationComposite: 15 * 60 * 1000,
	applicationGroups: 15 * 60 * 1000,
	applicationGrouped: 15 * 60 * 1000,
	offerList: 15 * 60 * 1000,
	customerSegments: 15 * 60 * 1000,
	filerUnit: 15 * 60 * 1000,
	locations: 15 * 60 * 1000,
	customerHierarchy: 15 * 60 * 1000,
	globalList: 15 * 60 * 1000,
	attributeDescriptions: 15 * 60 * 1000,
	brands: 15 * 60 * 1000,
};
